const AppConstants = {
    apiRootUrl: process.env.REACT_APP_API,
    contentRootUrl: `${process.env.REACT_APP_API}/file`,
    langKey: 'vi',
    socketHost: process.env.REACT_APP_SOCKET_HOST,
    apiTenantUrl: process.env.REACT_APP_API_TENANT,
    apiMediaUrl: process.env.REACT_APP_API_MEDIA,
    clientId: process.env.REACT_APP_CLIENT_ID,
    clientSecret: process.env.REACT_APP_CLIENT_SECRET,
}

const StorageKeys = {
    restaurantData: 'app-restaurant',
    foodGroup: 'app-food-group',
    cartDetails: 'app-cart',
    appLanguage: 'app-language',
    userData: 'app-user',
    order: 'app-order',
    orderWaitingPayment: 'order-payment',
    lastInnerHeight: 'last-vh',
    modalState: 'app-modal-state'
}

// User role

export const ROLE_SUPER_USER = 'ROLE_SUPER_USER'
export const ROLE_ADMIN = 'ROLE_ADMIN'

// Pagination config
export const DEFAULT_TABLE_ITEM_SIZE = 10
export const DATE_FORMAT_DISPLAY = 'DD-MM-YYYY'
export const DATE_FORMAT_VALUE = 'YYYY-MM-DD'
export const FULL_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss'

// Common status
export const STATUS_INACTIVE = 0
export const STATUS_ACTIVE = 1
export const STATUS_LOCK = -1
export const STATUS_DELETE = -2

// Register form
export const REG_SOURCE_PHONE = 1
export const REG_SOURCE_FACEBOOK = 2
export const REG_SOURCE_GOOGLE = 3

// Gender
export const GENDER_MALE = 1
export const GENDER_FEMALE = 2

export const COLOR_NAME = {
    LAYOUT_TEXT: 'main_text_color',
    LAYOUT_BG: 'sub_bg_color',
    LAYOUT_LINE: 'line_color',
    LAYOUT_ICON: 'sub_text_color',

    BODY_TEXT: 'main_text_color',
    BODY_TEXT_SUB: 'BODY_TEXT_SUB',
    BODY_BG: 'main_bg_color',
    BODY_LINE: 'line_color',
    BODY_ICON: 'sub_text_color',

    BUTTON_TEXT: 'main_text_color',
    BUTTON_BG: 'sub_bg_color',
    BUTTON_LINE: 'line_color',
    BUTTON_ICON: 'main_text_color',

    MODAL_TEXT: 'main_text_color',
    MODAL_BG: 'sub_bg_color',
    MODAL_LINE: 'line_color',
    MODAL_ICON: 'main_text_color',

    SIDEBAR_TEXT: 'main_text_color',
    SIDEBAR_BG: 'sub_bg_color',
    SIDEBAR_LINE: 'line_color',
    SIDEBAR_ICON: 'sub_text_color',
    SIDEBAR_HEAD_BG: 'sub_bg_color',

    BOX_TEXT: 'main_text_color',
    BOX_BG: 'box_body_bg_color',
    BOX_HEAD_BG: 'box_header_bg_color',
    BOX_LINE: 'line_color',
    BOX_ICON: 'main_text_color',

    INPUT_TEXT: 'main_text_color',
    INPUT_BG: 'main_bg_color',
    INPUT_LINE: 'line_color',
    INPUT_ICON: 'main_text_color',

    CART_BG: 'sub_bg_color',
    CART_ICON: 'sub_text_color',
}

export const COLOR_SETTINGS = {
    // [COLOR_NAME.LAYOUT_TEXT]: '000000',
    // [COLOR_NAME.LAYOUT_BG]: 'FFC600',
    // [COLOR_NAME.LAYOUT_LINE]: '929292',
    // [COLOR_NAME.LAYOUT_ICON]: 'FFFFFF',

    // [COLOR_NAME.BODY_TEXT]: '000000',
    // [COLOR_NAME.BODY_TEXT_SUB]: '6B6B6B',
    // [COLOR_NAME.BODY_BG]: 'FFFFFF',
    // [COLOR_NAME.BODY_LINE]: '929292',
    // [COLOR_NAME.BODY_ICON]: '000000',

    // [COLOR_NAME.BUTTON_TEXT]: '000000',
    // [COLOR_NAME.BUTTON_BG]: 'FFC600',
    // [COLOR_NAME.BUTTON_LINE]: '929292',
    // [COLOR_NAME.BUTTON_ICON]: '000000',

    // [COLOR_NAME.MODAL_TEXT]: '000000',
    // [COLOR_NAME.MODAL_BG]: 'FFC600',
    // [COLOR_NAME.MODAL_LINE]: '929292',
    // [COLOR_NAME.MODAL_ICON]: 'FFFFFF',

    // [COLOR_NAME.SIDEBAR_TEXT]: '000000',
    // [COLOR_NAME.SIDEBAR_BG]: 'FFC600',
    // [COLOR_NAME.SIDEBAR_LINE]: '929292',
    // [COLOR_NAME.SIDEBAR_ICON]: 'FFFFFF',
    // [COLOR_NAME.SIDEBAR_HEAD_BG]: 'F2BA08',

    // [COLOR_NAME.BOX_TEXT]: '000000',
    // [COLOR_NAME.BOX_BG]: 'F4F4F4',
    // [COLOR_NAME.BOX_LINE]: 'FFFFFF',
    // [COLOR_NAME.BOX_ICON]: '000000',

    // [COLOR_NAME.INPUT_TEXT]: '000000',
    // [COLOR_NAME.INPUT_BG]: 'FFFFFF',
    // [COLOR_NAME.INPUT_LINE]: '929292',
    // [COLOR_NAME.INPUT_ICON]: '000000',

    // [COLOR_NAME.CART_BG]: 'FFC600',
    // [COLOR_NAME.CART_ICON]: 'FFFFFF',
    main_bg_color: 'FFFFFF',
    sub_bg_color: 'FFC600',
    main_text_color: '000000',
    sub_text_color: 'FFFFFF',
    box_header_bg_color: 'ADADAD',
    box_body_bg_color: 'F4F4F4',
    line_color: '929292',
}

// Phương thức đặt hàng, tới lấy - giao hàng - tại cửa hàng
export const ORDER_METHOD = {
    PICKUP: 'pickup',
    QR_CODE: 'qr_code',
    DELIVERY: 'delivery',
    TABLE_QRCODE: 'table_qrcode',
}

export const TABLET_ORDER_METHOD = {
    AT_RES: '0',
    TAKE_A_GO: '1',
}

export const ORDER_METHOD_MAP = {
    [ORDER_METHOD.PICKUP]: 'PICKUP',
    [ORDER_METHOD.DELIVERY]: 'DELIVERY',
}

export const ACCESS_SERVICES_MAP = {
    [ORDER_METHOD.PICKUP]: 'PICKUP', // web - đến lấy
    [ORDER_METHOD.QR_CODE]: 'QRCODE', // tại bàn
    [ORDER_METHOD.DELIVERY]: 'DELIVERY', // web - giao hàng
    [ORDER_METHOD.TABLE_QRCODE]: 'QRCODE_CUSTOMER', // tại nhà hàng
    WEB: 'web',
}

export const PAYMENT_METHOD = {
    PAYPAL: 5,
    CASH: 1,
    CASH_CARD: 2,
    EC: 4,
}

export const PAYMENT_METHOD_CONFIG = {
    OFFLINE_CASH: 'OFFLINE_CASH',
    OFFLINE_CARD: 'OFFLINE_CARD',
    ONLINE_PAYPAL: 'ONLINE_PAYPAL',
}

export const FOOD_KIND = {
    FOOD_CHOICE: 4,
    FOOD_GROUP: 3,
    FOOD_SUBS: 5,
    NORMAL: 1,
}

export const FOOD_STATUS = {
    ACTIVE: 1,
    DISABLED: -1,
    SOLD_OUT: 0,
}

export const BEILAGE_OPTION_TYPE = {
    SINGLE: 0,
    MULTI: 1,
}

export const FOOD_TYPES = {
    FOOD_TYPE_IN: 1,
    FOOD_TYPE_OUT: 2,
    FOOD_TYPE_DELIVER: 3,
    FOOD_TYPE_PICKUP: 4
}

export { AppConstants, StorageKeys }

export const DELIVERY_TIME = 'Chọn thời gian giao'

export const PARAMS_NAME = {
    ORDER_WEB_ID: 'wOId',
    ORDER_GO_ID: 'goOId',
    ORDER_CODE: 'oc',
    ORDER_WAIT_PAYMENT: 'pmtOId',
}

export const APP_SERVICE = process.env.REACT_APP_SERVICE_TYPE

// milliseconds
export const INACTIVE_EXPIRE_TIME = 900000

export const COMMON_STATUS = {
    ACTIVE: 1
}

export const MODAL_KEYS = {
    tableQrcodeQuestion: 'tableQrcodeQuestion',
    tableQrcodePrinter: 'tableQrcodePrinter',
}

export const REQUEST_KINDS = {
    supporter: 2,
    payment: 1,
    continueOrder: 3
}

export const VOUCHER_TYPE_PERCENT = 1
export const VOUCHER_TYPE_AMOUNT = 2

export const VALUE_TYPES = {
    FIXED: 'FIXED',
    PERCENTAGE: 'PERCENTAGE'
}

export const HAPPY_HOUR = {
    YES: 1,
    NO: 0
}
